import { useSelector } from 'react-redux';
import clsx from 'clsx';

import Dropdown from '@components/drop-down/Dropdown';
import { S3_URL } from '@constants/generic';

import { defaultCountryCode } from './constants';
import { CountryCodeOptions, CountryCodeProps, CountryData } from './types';

const CountryCode = (props: CountryCodeProps) => {
  const {
    className,
    hasSelection,
    countryCode = defaultCountryCode,
    setCountryCode,
    listId,
    titleWrapperStyle,
    showFlag = false,
    dropdownStyle = '!bg-cofeeNeutral1',
    usePortal = false,
    titleLabelStyle = 'text-cofeeNeutral10'
  } = props;

  const renderOption = (label: string, code: string) => (
    <div className={`flex items-center ${titleWrapperStyle || ''}`}>
      <div className="flex items-center gap-2 text-base font-medium text-content">
        {showFlag ? (
          <img
            src={`${S3_URL}/country_flag/${code}.png`}
            alt="flag"
            className="h-4 w-5"
          />
        ) : (
          <span className={`text-base font-medium ${titleLabelStyle || ''}`}>
            +
          </span>
        )}
        <span className={`text-base font-medium ${titleLabelStyle || ''}`}>
          {label}
        </span>
      </div>
    </div>
  );

  const { appConfig } = useSelector((state: any) => state.user);

  const countryCodeOptions: CountryCodeOptions[] = (
    appConfig?.supported_phone_number_countries || []
  ).map((country: CountryData) => ({
    id: `${country.dial_code}`,
    label: `${country.dial_code}`,
    value: `${country.dial_code}`,
    element: renderOption(`${country.dial_code}`, country.code)
  }));

  const selectedCountry = countryCodeOptions.find(
    (option) => option.id === countryCode
  );

  return (
    <div className={className}>
      {hasSelection && setCountryCode ? (
        <Dropdown
          currentFilter={countryCode}
          filterOptions={countryCodeOptions}
          onSelectFilter={(option) => setCountryCode?.(option)}
          className={`!h-12.5 !min-w-max  !rounded-lg ${dropdownStyle} `}
          optionsStyle="left-0 !min-w-32 !max-w-40 !max-h-60 !overflow-y-auto !rounded-lg"
          listId={listId}
          searchBarPlaceholder="Search"
          isSearchDigitsOnly
          usePortal={usePortal}
        />
      ) : (
        <div
          className={clsx(
            `flex h-12.5 w-full items-center justify-start gap-2 rounded-xl border ${dropdownStyle} p-4`,
            className
          )}
        >
          {selectedCountry?.element}
        </div>
      )}
    </div>
  );
};

export default CountryCode;
